//Used for appointements table in the admin appointments desktop view
const TableHeaderColumn = [
  { id: "status", label: "State" },
  { id: "startDate", label: "Date" },
  { id: "type", label: "Service" },
  { id: "email", label: "UserEmail" },
  { id: "phoneNumber", label: "PhoneNumber" },
  { id: "pet_name", label: "Pet" },
];

const TABLE_CELL_ALIGNMENT = "center";

export { TableHeaderColumn, TABLE_CELL_ALIGNMENT };
